import { useLang } from '@/hooks/useLang';

const copy = {
  EN: {
    tag: 'Process',
    title: 'How It Works',
    sub: 'Four steps. Zero friction.',
    steps: [
      {
        num: '01',
        icon: 'ri-lightbulb-line',
        title: 'Idea',
        desc: 'You bring the vision. We listen, ask the right questions, and map the creative direction.',
      },
      {
        num: '02',
        icon: 'ri-cpu-line',
        title: 'Generate',
        desc: 'Our AI engine transforms your brief into storyboards, scripts, and visual concepts.',
      },
      {
        num: '03',
        icon: 'ri-scissors-cut-line',
        title: 'Shape',
        desc: 'Human creativity meets AI precision. We refine, edit, and perfect every frame.',
      },
      {
        num: '04',
        icon: 'ri-send-plane-line',
        title: 'Deliver',
        desc: 'Final content delivered in any format, any language, ready to publish.',
      },
    ],
  },
  TR: {
    tag: 'Süreç',
    title: 'Nasıl Çalışır',
    sub: 'Dört adım. Sıfır sürtüşme.',
    steps: [
      {
        num: '01',
        icon: 'ri-lightbulb-line',
        title: 'Fikir',
        desc: 'Vizyonu siz getirin. Biz dinler, doğru soruları sorar ve yaratıcı yönü belirleriz.',
      },
      {
        num: '02',
        icon: 'ri-cpu-line',
        title: 'Üret',
        desc: 'Yapay zeka motorumuz brifinizi storyboard, senaryo ve görsel konseptlere dönüştürür.',
      },
      {
        num: '03',
        icon: 'ri-scissors-cut-line',
        title: 'Şekillendir',
        desc: 'İnsan yaratıcılığı yapay zeka hassasiyetiyle buluşur. Her kareyi mükemmelleştiririz.',
      },
      {
        num: '04',
        icon: 'ri-send-plane-line',
        title: 'Teslim Et',
        desc: 'Her formatta, her dilde, yayına hazır nihai içerik teslim edilir.',
      },
    ],
  },
};

export default function HowItWorksSection() {
  const lang = useLang();
  const t = copy[lang];

  return (
    <section id="how-it-works" className="py-32 bg-white">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16">
        {/* Header */}
        <div className="text-center max-w-xl mx-auto mb-20">
          <span className="text-xs font-semibold text-gray-400 tracking-widest uppercase mb-3 block">{t.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight mb-4" style={{ fontFamily: '\'Space Grotesk\', sans-serif' }}>
            {t.title}
          </h2>
          <p className="text-gray-400 text-base">{t.sub}</p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-gray-100 z-0" />

          {t.steps.map((step, idx) => (
            <div key={step.num} className="relative flex flex-col items-center text-center group">
              {/* Step number + icon */}
              <div className="relative z-10 mb-6">
                <div className="w-20 h-20 rounded-2xl bg-gray-50 border border-gray-100 flex items-center justify-center mx-auto group-hover:bg-gray-900 group-hover:border-gray-900 transition-all duration-300">
                  <i className={`${step.icon} text-2xl text-gray-300 w-6 h-6 flex items-center justify-center group-hover:text-white transition-colors duration-300`}></i>
                </div>
                <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border border-gray-100 flex items-center justify-center text-xs font-black text-gray-300" style={{ fontFamily: '\'Space Grotesk\', sans-serif' }}>
                  {idx + 1}
                </span>
              </div>

              <h3 className="text-2xl font-black text-gray-900 mb-3" style={{ fontFamily: '\'Space Grotesk\', sans-serif' }}>
                {step.title}
              </h3>
              <p className="text-sm text-gray-400 leading-relaxed max-w-[200px]">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
